import { useState, useEffect } from 'react';

export default function CTA() {
  const [copied, setCopied] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    days: 5,
    hours: 12,
    minutes: 30,
    seconds: 45
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let { days, hours, minutes, seconds } = prev;
        
        if (seconds > 0) {
          seconds--;
        } else {
          seconds = 59;
          if (minutes > 0) {
            minutes--;
          } else {
            minutes = 59;
            if (hours > 0) {
              hours--;
            } else {
              hours = 23;
              if (days > 0) {
                days--;
              }
            }
          }
        }
        
        return { days, hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText('RAMESCO');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="relative py-32 bg-gradient-to-b from-[#0A1628] via-[#0D1B3A] to-black overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'linear-gradient(rgba(6, 182, 212, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(6, 182, 212, 0.1) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }}></div>
        <div className="absolute top-20 left-20 w-96 h-96 bg-cyan-500 rounded-full filter blur-[150px] opacity-20"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-purple-600 rounded-full filter blur-[150px] opacity-20"></div>
      </div>

      {/* Floating Particles */}
      <div className="absolute inset-0 overflow-hidden">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-cyan-400 rounded-full opacity-30 animate-float-particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 10}s`
            }}
          ></div>
        ))}
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="text-center space-y-8">
          {/* Badge */}
          <div className="inline-block px-6 py-2 bg-red-500 rounded-full animate-pulse">
            <span className="text-white text-sm font-bold uppercase tracking-wider">
              Limited Time Offer
            </span>
          </div>

          {/* Countdown Timer */}
          <div className="flex items-center justify-center gap-6">
            {Object.entries(timeLeft).map(([unit, value]) => (
              <div key={unit} className="text-center">
                <div className="w-20 h-20 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl flex items-center justify-center mb-2">
                  <span className="text-4xl font-black text-white">
                    {value.toString().padStart(2, '0')}
                  </span>
                </div>
                <span className="text-sm text-gray-400 uppercase tracking-wider">
                  {unit}
                </span>
              </div>
            ))}
          </div>

          {/* Headline */}
          <h2 className="text-6xl font-black text-white leading-tight">
            Don't Miss Your<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              55% Discount
            </span>
          </h2>

          <p className="text-2xl text-gray-300 max-w-2xl mx-auto">
            Join the QT Funded community today with exclusive RAMESCO pricing
          </p>

          {/* Promo Code Display */}
          <div className="inline-block p-8 bg-gradient-to-r from-cyan-500/20 to-purple-600/20 border-2 border-cyan-500/50 rounded-2xl backdrop-blur-md shadow-2xl shadow-cyan-500/20">
            <p className="text-sm text-gray-400 mb-3">Your Exclusive Code</p>
            <div className="flex items-center gap-6">
              <p className="text-5xl font-mono font-black text-white tracking-widest">
                RAMESCO
              </p>
              <button
                onClick={handleCopy}
                className="px-6 py-3 bg-cyan-500 hover:bg-cyan-600 text-white font-bold rounded-xl transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer"
              >
                {copied ? (
                  <>
                    <i className="ri-check-line text-xl"></i>
                    Copied!
                  </>
                ) : (
                  <>
                    <i className="ri-file-copy-line text-xl"></i>
                    Copy
                  </>
                )}
              </button>
            </div>
          </div>

          {/* CTA Button */}
          <div className="pt-4">
            <a
              href="https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-12 py-6 bg-gradient-to-r from-cyan-500 to-blue-600 text-white text-2xl font-black rounded-full hover:shadow-2xl hover:shadow-cyan-500/50 hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Claim Your Discount Now
              <i className="ri-arrow-right-line text-3xl"></i>
            </a>
          </div>

          {/* Support Link */}
          <div>
            <a
              href="https://qtfunded.quanttekel.com/ref/5428/?campaign=ramesco"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-cyan-400 hover:text-cyan-300 transition-colors cursor-pointer"
            >
              Questions? Chat with our team
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
